import useResizeObserver from '@react-hook/resize-observer';
import DateTimeSelect from 'components/Form/DateTimeSelect';
import Dropdown from 'components/Form/Dropdown';
import InputText from 'components/Form/InputText';
import SubmitButton from 'components/Form/SubmitButton';
import Layout from 'components/Layout';
import LinkButton from 'components/LinkButton';
import {FC, MutableRefObject, useRef, useState} from 'react';
import {useFormContext} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {jstDateString} from 'utils/date';
import {setUrl} from 'utils/request';

import {EventsBackendData, FilterFormData} from '../types';

const Filter: FC = () => {
    const {
        data: {actions, creators, isFiltered},
    } = useBackend<EventsBackendData>();

    const {handleSubmit} = useFormContext<FilterFormData>();

    const [isSmallScreen, setIsSmallScreen] = useState<boolean>();

    const sectionRef: MutableRefObject<HTMLElement | null> = useRef(
        document.querySelector('#section'),
    );

    useResizeObserver(sectionRef, () => {
        if (
            sectionRef.current?.clientWidth &&
            sectionRef.current?.clientWidth <= 760
        ) {
            setIsSmallScreen(true);
        } else {
            setIsSmallScreen(false);
        }
    });

    const onFilter = (formData: FilterFormData) => {
        const builtUrl = new URL(window.location.href.split('?')[0]);

        const queryParameters = new URLSearchParams(builtUrl.search);

        Object.entries(formData).forEach(([key, value]) => {
            if (value) {
                if (key === 'date_begin' || key === 'date_end') {
                    queryParameters.append(key, jstDateString(value));
                } else {
                    queryParameters.append(key, value);
                }
            }
        });

        builtUrl.search = queryParameters.toString();

        setUrl(builtUrl.toString());
    };

    return (
        <form onSubmit={handleSubmit(onFilter)}>
            <Layout.Chain className="mt-4">
                <Dropdown
                    fieldClassName={isSmallScreen ? 'w-32' : 'w-44'}
                    isCompact={true}
                    isSearchable={true}
                    name="action_flag"
                    options={actions}
                    placeholder={t`All Actions`}
                    type="select"
                />
                <Dropdown
                    fieldClassName="w-40"
                    isCompact={true}
                    name="created_by"
                    options={creators}
                    placeholder={t`All Members`}
                    type="select"
                />
                <InputText
                    className="min-w-32 flex-1"
                    classNameInput="w-full"
                    isCompact={true}
                    name="object_repr"
                    placeholder={t`Item Name`}
                />
                <DateTimeSelect
                    className="max-w-44"
                    isCompact={true}
                    name="date_begin"
                    placeholder={t`From`}
                />
                <DateTimeSelect
                    className="max-w-44"
                    isCompact={true}
                    name="date_end"
                    placeholder={t`To`}
                />
                <SubmitButton
                    className="min-w-10"
                    icon="search"
                    kind="secondary"
                    size="sm"
                    title={t`Filter`}
                />
                {isFiltered && (
                    <LinkButton
                        className="min-w-10"
                        href={window.Urls.history_view()}
                        icon="close"
                        kind="secondary"
                        size="sm"
                        title={t`Clear`}
                    />
                )}
            </Layout.Chain>
        </form>
    );
};

export default Filter;
